import PropTypes from 'prop-types';

export default PropTypes.shape({
	officeLocationNumber: PropTypes.oneOf([1, 2, 3, 4]),
	address: PropTypes.string,
	address2: PropTypes.string,
	city: PropTypes.string,
	state: PropTypes.string,
	zip: PropTypes.string,
	phone: PropTypes.string
});